export type Customer = {
    cvr: string;
    existsInCRM: boolean;
    hasAcceptedPrivacyPolicy: boolean;
    hasCows: boolean;
    hasPigs: boolean;
    hasPlants: boolean;
    hasPoultry: boolean;
    isOrganic: boolean;
    isOwner: boolean;
    isPrimaryAccount: boolean;
    name: string;
    number: string;
    role?: string;
};

export type Account = {
    customers: Customer[];
};

export type Data = {
    firstName: string;
    lastName: string;
    defaultCustomerNumber: string;
    accounts: Account[];
};

export const useAccessControl = (data: Data) => {
    const findOwnerStatusByDefaultCustomerNumber = (): boolean | null => {
        const { defaultCustomerNumber, accounts } = data;

        for (const account of accounts) {
            for (const customer of account.customers) {
                if (customer.number === defaultCustomerNumber) {
                    return customer.isOwner;
                }
            }
        }
        return null;
    };

    const isOwner = findOwnerStatusByDefaultCustomerNumber();
    // Assume these come from global state, context, or arguments
    const isAdmin = globalThis?.isAdmin;
    const isMasterAdmin = globalThis?.isMasterAdmin;

    const hasAccess = !!isOwner || !!isAdmin || !!isMasterAdmin;

    return hasAccess;
};
